'use strict';
var inputAll = document.querySelectorAll('input');
inputAll.forEach(function(el) {
    var nameValue = el.getAttribute('name');
    var formattedName = nameValue[0].toUpperCase() + nameValue.slice(1);
    var label = document.createElement('label');
    label.className = 'field-label';
    label.setAttribute('for', el.id);
    label.textContent = nameValue;
    el.placeholder = formattedName;
    el.before(label);
});

//# sourceMappingURL=js_task_fix_form_DOM.39dd71a7.js.map
